export default __webpack_public_path__ + "static/sveriges-larare-logo-a647dfcfb82686c1f99179ddf49c4a78.svg";